import { api } from "../../api"

export async function loadTemperature(): Promise<{ temperature: number }> {
    let temperature = await api<any>("temperature", {})
    return temperature.data[0]
}
